// ─── Face-cover alerts: their own feedback profile ────────────────────────────
//
// Face-cover alerts (detector `face_cover`) are reviewed with their OWN reasons —
// alert_feedback.FC_REASONS on the box. The person-detection reasons (foliage,
// insect …) mean nothing for a covered face, and the box rejects them for these
// alerts. Every other alert keeps the screens' existing reason lists untouched.
//
// Codes must match alert_feedback.FC_REASONS. GET /alerts/{id}/info also returns
// them as `fa_reasons`; this copy is for lists where only the filename is known.

export const isFaceCoverAlert = a =>
  String((a && (a.filename || a.id)) || a || '').startsWith('face_cover_');

// kind: wrong → tightens a threshold · allowed → scope only (zone / hours) ·
//       bug → should never happen; flagged on the camera's health card
export const FC_REASONS = [
  { value: 'fcv_vis',     label: '👀 Face was visible',               kind: 'wrong' },
  { value: 'fcv_beard',   label: '🧔 Beard / shadow read as a mask',   kind: 'wrong' },
  { value: 'fcv_back',    label: '🔙 Back of the head',               kind: 'bug' },
  { value: 'fcv_turn',    label: '↪️ Turned away / side-on',           kind: 'wrong' },
  { value: 'fcv_hand',    label: '✋ Hand / phone / cup at face',       kind: 'wrong' },
  { value: 'fcv_far',     label: '🔭 Too far / blurry',               kind: 'wrong' },
  { value: 'fcv_med',     label: '😷 Medical mask — allowed here',     kind: 'allowed' },
  { value: 'fcv_relig',   label: '🧕 Religious / cultural covering',   kind: 'allowed' },
  { value: 'fcv_winter',  label: '🧣 Winter wear — allowed',           kind: 'allowed' },
  { value: 'fcv_helmet',  label: '🪖 Helmet — allowed here',           kind: 'allowed' },
  { value: 'fcv_staff',   label: '👷 Staff / uniform',                 kind: 'allowed' },
  { value: 'fcv_allowed', label: '✅ Covering is allowed here',        kind: 'allowed' },
  { value: 'fcv_oth',     label: '❓ Other',                           kind: 'other' },
];

// From an alert-info payload's `fa_reasons` map, falling back to the copy above.
export function reasonsFromInfo(info, fallback) {
  const m = info && info.fa_reasons;
  if (!m) return fallback;
  return Object.entries(m).map(([value, label]) => ({ value, label, code: value }));
}
